import { useLayoutEffect } from "react"
import { useSearchParamsCompat } from "@/lib/router-helpers"
import { useBookingStore, readPendingBooking, clearPendingBooking } from "@/store/booking-store"
import { setSelectedBranch } from "@/lib/auth"
import BookingWizardPage from "@/pages/BookingWizard"

// Survives React StrictMode's extra unmount/remount so a pending restore
// is not immediately wiped by the default branch reset.
let lastPendingRestoreAt = 0
const STRICT_MODE_RESTORE_WINDOW_MS = 500

export default function OrganizationDarsPage() {
  const [sp] = useSearchParamsCompat()
  const { setBookingState, resetBookingState } = useBookingStore()
  const mode = (sp.get("mode") as "booking" | "reschedule") || "booking"
  const appointmentId = sp.get("appointment_id")

  // When landing on /organization/dars from home, reset the booking flow.
  // When returning from login, restore the branch the user already selected.
  useLayoutEffect(() => {
    const pending = readPendingBooking()

    if (pending?.selectedBranch) {
      setBookingState({
        selectedBranch: pending.selectedBranch,
        selectedService: null,
        selectedSlot: null,
        selectedDate: null,
        mode: pending.mode || mode,
        appointmentId: pending.appointmentId ?? appointmentId,
        bookingType: pending.bookingType || "self",
        bookingStep: "service",
      })
      setSelectedBranch(pending.selectedBranch.id)
      clearPendingBooking()
      lastPendingRestoreAt = Date.now()
      return
    }

    if (Date.now() - lastPendingRestoreAt < STRICT_MODE_RESTORE_WINDOW_MS) {
      return
    }

    resetBookingState()
    setBookingState({
      mode,
      appointmentId: appointmentId,
      bookingStep: "branch",
    })
  }, [mode, appointmentId, setBookingState, resetBookingState])

  return <BookingWizardPage />
}
